import type { Translator } from './types'
import { toStructuredErrorMessage } from './payloads'

export const sanitizeSetupErrorMessage = ({
  message,
  t,
}: {
  message: string
  t: Translator
}): string => {
  const normalized = message.toLowerCase()
  if (message.includes('SETUP_BOOTSTRAP_SECRET') || normalized.includes('bootstrap secret')) {
    return t('setup.errors.authorizationKey')
  }
  if (normalized.includes('setup completion disabilitato') || normalized.includes('setup completion disabled')) {
    return t('setup.errors.setupUnavailable')
  }
  return message
}

export const isCsrfFailure = (response: Response, data: Record<string, unknown> | null, raw: string): boolean => {
  if (response.status !== 403) return false
  const message = `${toStructuredErrorMessage(data) ?? ''} ${raw}`.toLowerCase()
  return message.includes('csrf')
}
